import _ from 'underscore';
import { IFormattedScope, IQueryParams, ScopeParameter } from '../types';

const NUMERIC_PATTERN = /^-?[0-9]+$/;
const SAFE_INTEGER = 9007199254740991;

export function scopeFormatter(scope: IQueryParams): IFormattedScope {
  return _.mapObject(scope, (rawValue: ScopeParameter) => {
    // Values in an array already share a key, so collapse only exact value duplicates.
    const rawValues = rawValue as Array<string | number | boolean | null>;
    const hasOnlyDuplicateValues = _.isArray(rawValue)
      && rawValues.length > 1
      && _.every(rawValues, (value: ScopeParameter) => value === rawValues[0]);
    const value = hasOnlyDuplicateValues ? rawValues[0] : rawValue;

    if (_.isString(value) && NUMERIC_PATTERN.test(value)) {
      const intValue = parseInt(value, 10);
      if (intValue.toString() === value && Math.abs(intValue) <= SAFE_INTEGER) {
        return intValue;
      }
    }
    return value;
  }) as IFormattedScope;
}
